import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';
import Media from 'react-media';

class Header extends Component {
    static propTypes = {};

    render() {
        return (
            <div className="pt3 pb1">
                <div className="flex items-center">
                    <Link to="/">
                        <h1 css={{ margin: 0 }}>alan honey photography</h1>
                    </Link>
                    <div className="flex-auto" />

                    <Media query="(max-width: 650px)">
                        {(matches) => (
                            <div className={matches ? 'flex flex-column' : 'flex'}>
                                <NavLink
                                    activeClassName="underline"
                                    to="/galleries"
                                    className="ml3 nowrap"
                                >
                                    galleries
                                </NavLink>
                                <NavLink
                                    activeClassName="underline"
                                    to="/about"
                                    className="ml3 nowrap"
                                >
                                    about us
                                </NavLink>
                            </div>
                        )}
                    </Media>
                </div>
                <hr />
            </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/core/components/Header.js